import script from "./RevisionWidgets.vue?vue&type=script&setup=true&lang=js"
export * from "./RevisionWidgets.vue?vue&type=script&setup=true&lang=js"

import "./RevisionWidgets.vue?vue&type=style&index=0&id=2ff2174b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff2174b"]])

export default __exports__